import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useAnalyticsPush } from '@/context/analyticsContext'

const Analytics = () => {
  const { pushEvent } = useAnalyticsPush()
  const router = useRouter()

  useEffect(() => {
    pushEvent({
      event: 'pageview',
    })
  }, [router.asPath])
  return null
}

export default Analytics
